/**
 * The colour palettes offered by the right panel's "Colour palettes" tab.
 *
 * Each palette is a ten-step LIGHT → DARK ramp. That order is the whole mechanism:
 * every colour in a design — vector fills, text, frame backgrounds AND image pixels
 * — is placed on the ramp by its own lightness, so the artwork takes the palette on
 * while keeping its contrast (see utils/paletteRecolor and utils/paletteImage).
 *
 * Lives in the schema rather than in the panel because a saved document only stores
 * the palette's `id`; the renderers resolve the ramp from here.
 */

export const COLOR_PALETTES = [
    {
        id: 'mono',
        name: 'Mono',
        colors: ['#f8fafc', '#e2e8f0', '#cbd5e1', '#94a3b8', '#64748b', '#475569', '#334155', '#1e293b', '#111827', '#0f172a'],
    },
    {
        id: 'sohozkaj',
        name: 'Sohozkaj',
        colors: ['#fff7ed', '#ffe8c9', '#ffb347', '#ff8a00', '#f97316', '#ea580c', '#c2410c', '#93370d', '#7c2d12', '#111827'],
    },
    {
        id: 'ocean',
        name: 'Ocean',
        colors: ['#eff6ff', '#dbeafe', '#93c5fd', '#3b82f6', '#2563eb', '#1d4ed8', '#1e40af', '#1e3a8a', '#172554', '#0f172a'],
    },
    {
        id: 'forest',
        name: 'Forest',
        colors: ['#f0fdf4', '#dcfce7', '#86efac', '#4ade80', '#22c55e', '#16a34a', '#15803d', '#166534', '#14532d', '#0f172a'],
    },
    {
        id: 'sunset',
        name: 'Sunset',
        colors: ['#fff7ed', '#fee2e2', '#fca5a5', '#fb7185', '#f97316', '#f59e0b', '#ef4444', '#b91c1c', '#7f1d1d', '#581c1c'],
    },
    {
        id: 'berry',
        name: 'Berry',
        colors: ['#f5f3ff', '#ede9fe', '#ddd6fe', '#c4b5fd', '#a78bfa', '#8b5cf6', '#7c3aed', '#6d28d9', '#5b21b6', '#381f7a'],
    },
    {
        id: 'sand',
        name: 'Sand',
        colors: ['#fdf2f8', '#f8fafc', '#fef3c7', '#fde68a', '#fbbf24', '#f59e0b', '#d97706', '#b45309', '#92400e', '#713f12'],
    },
    {
        id: 'lavender',
        name: 'Lavender',
        colors: ['#f3e8ff', '#e9d5ff', '#d8b4fe', '#c084fc', '#a855f7', '#9333ea', '#7e22ce', '#6d28d9', '#5b21b6', '#4c1d95'],
    },
    {
        id: 'mint',
        name: 'Mint',
        colors: ['#effaf3', '#dcfce7', '#bbf7d0', '#86efac', '#4ade80', '#22c55e', '#16a34a', '#15803d', '#14532d', '#0f3d2e'],
    },
    {
        id: 'coral',
        name: 'Coral',
        colors: ['#fff1f2', '#ffe4e6', '#fecdd3', '#fda4af', '#fb7185', '#f43f5e', '#e11d48', '#be123c', '#9f1239', '#881337'],
    },
    {
        id: 'steel',
        name: 'Steel',
        colors: ['#f1f5f9', '#e2e8f0', '#cbd5e1', '#94a3b8', '#64748b', '#475569', '#334155', '#1e293b', '#0f172a', '#020617'],
    },
];

const BY_ID = new Map(COLOR_PALETTES.map((p) => [p.id, p]));

export function paletteById(id) {
    return (id && BY_ID.get(id)) || null;
}

/** The ramp for a palette id, or null — what the renderers ask for. */
export function paletteRamp(id) {
    return paletteById(id)?.colors || null;
}
